import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	goToLetalkButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
		}
	},
	container: {
		width: "100%",
		display: "flex",
		flexFlow: "column"
	},
	portlet: {
		marginTop: "auto",
		marginBottom: "auto"
	}
})

export default useStyles
